// Pure, framework-free helpers for FloatingSystemStatus.jsx — extracted for
// `node --test` coverage the same way sidebarNav.mjs/globalSearchLogic.mjs
// are. Consumes the shape healthAPI.getSystemStatus() resolves to
// (services/api.js): `{ auth, models, schema, predictions, timestamp }`,
// where each service key holds either a real health payload (`{ status:
// 'healthy', ... }`) or the client-side `{ status: 'down' }` fallback the
// API layer substitutes when that service's own /health call rejected.

export const SERVICES = [
  { key: 'auth', label: 'Authentication' },
  { key: 'models', label: 'Models' },
  { key: 'schema', label: 'Schema' },
  { key: 'predictions', label: 'Predictions' },
]

// A single service's raw status string ('healthy' | 'unhealthy' | 'error' |
// 'down' | anything else the backend might send) collapses to exactly two
// states the widget cares about — this is the ONLY string considered "up".
export function isServiceHealthy(status) {
  return status === 'healthy'
}

// Normalizes the getSystemStatus() payload into the flat rows the widget
// renders, defaulting to 'unknown' for a missing/malformed entry instead of
// throwing — a partially-shaped response must degrade gracefully, not crash
// the shell that wraps every page.
export function serviceRows(statusData) {
  return SERVICES.map(({ key, label }) => {
    const raw = statusData?.[key]
    const status = typeof raw?.status === 'string' ? raw.status : 'unknown'
    return { key, label, status, healthy: isServiceHealthy(status) }
  })
}

// Overall widget state:
//   'loading'  — no response yet (statusData is null/undefined)
//   'healthy'  — every service reports 'healthy'
//   'degraded' — at least one service is not 'healthy' (down/unhealthy/
//                error/unknown all count — an unrecognized status is not a
//                clean bill of health)
export function computeOverallStatus(statusData, loading) {
  if (loading || !statusData) return 'loading'
  const rows = serviceRows(statusData)
  return rows.every((r) => r.healthy) ? 'healthy' : 'degraded'
}
